import React from 'react'
import PropTypes from 'prop-types'
import Section, { ExpandedContent, SectionHeader } from './Section'
import pluralize from 'pluralize'
import ServiceArea from './ServiceArea'
import ServiceAreaShape from './prop_shapes/service_area'

const ServiceAreaSection = (props) => {
  function calloutText (serviceArea) {
    const keys = Object.keys(serviceArea.counties_by_state || {})

    const dc = keys.includes('DC')
    const count = dc ? keys.length - 1 : keys.length

    if (serviceArea.national) {
      return 'NATIONAL'
    } else if (count > 0) {
      return `${count} ${pluralize('State', count).toUpperCase()} ${
        count && dc ? ' and ' : ''
      } ${dc ? 'D.C.' : ''}`
    } else if (dc) {
      return 'D.C.'
    } else {
      return ''
    }
  }

  return (
    <Section
      expandable
      idText='service-area'
      padded
    >
      <SectionHeader
        callout={calloutText(props.serviceArea)}
        idText='service-area'
        editButton={props.editButton}
      >
        Service Area
      </SectionHeader>

      <ExpandedContent>
        <ServiceArea serviceAreas={props.serviceArea} />
      </ExpandedContent>
    </Section>
  )
}

ServiceAreaSection.propTypes = {
  serviceArea: ServiceAreaShape,
  editButton: PropTypes.element
}

ServiceAreaSection.defaultProps = {
  serviceArea: {},
  editButton: null
}

export default ServiceAreaSection
